import lodash from 'lodash'
import React from 'react'

import Alert from '../../../../../1stlog-ui/src/components/Alert'
import Card from '../../../../../1stlog-ui/src/components/Card'
import { useField } from '../../../../../1stlog-ui/src/components/Field'
import { useCustoms } from '../../Form/Customs'
import { useProductSettings } from '../../Products'
import CustomsTerms from '../CustomsTerms'
import InvoiceDocuments from '../InvoiceDocuments'
import CustomsTable from './CustomsTable'

const Customs = (props) => {
  const {} = props

  const { isCustomsRequired } = useCustoms()

  const { isIncotermsHidden } = useProductSettings()

  const items = useField('customs')

  const invoiceDocument = useField('invoiceDocument')

  const additionalCustomsDocs = useField('additionalCustomsDocs')

  const customsTerms = useField('customsTerms')

  const proformaInvoice = useField('proformaInvoice')

  if (!isCustomsRequired) {
    return null
  }

  return (
    <>
      <Card title={i18n.t('order_customs', 'Zolldaten')}>
        {lodash.isEmpty(items) ? (
          <Alert warning>
            <strong>{i18n.t('caution_:', 'Achtung:')}</strong>{' '}
            {i18n.t(
              'you_have_not_specified_any_goods_for_customs_clearance',
              'Sie haben keine Waren zur Verzollung angegeben.',
            )}
          </Alert>
        ) : (
          <CustomsTable items={items} />
        )}
      </Card>
      {!isIncotermsHidden && <CustomsTerms customsTerms={customsTerms} />}
      <InvoiceDocuments
        invoiceDocument={invoiceDocument}
        additionalCustomsDocs={additionalCustomsDocs}
        proformaInvoice={proformaInvoice}
      />
    </>
  )
}

export default Customs
